import { render, staticRenderFns } from "./publicityDetail.vue?vue&type=template&id=04b704c1&scoped=true"
import script from "./publicityDetail.vue?vue&type=script&lang=js"
export * from "./publicityDetail.vue?vue&type=script&lang=js"
import style0 from "./publicityDetail.vue?vue&type=style&index=0&id=04b704c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b704c1",
  null
  
)

export default component.exports